import React from 'react'
import { connect } from 'react-redux'
import { localized } from 'decorators'
import { DetailPage } from 'components/page'
import { fromUrl } from 'utils/fromUrl'
import { updateEntity } from 'utils/updateEntity'

const createDetailPage = ({ metadata, actionCreators, Form }) => {
  const CommonDetailPage = (props) => {
    const { localize, get, save, delete: deleteAction, [metadata.page]: data, ...otherProps } = props
    const confirmDeleteMessage = metadata.hideDelete != true
      ? e => localize(metadata.isSoftDelete ? 'common.confirmDeleteOnDetailPage' : 'common.confirmHardDeleteOnDetailPage')
      : null;
    return (
      <DetailPage
        {...data}
        metadata={metadata}
        confirmDeleteMessage={confirmDeleteMessage}
        confirmDeleteTooltip={localize(`${metadata.page}.deleteEntity`)}
        getEntity={() => get({ id: fromUrl(props) })}
        save={save}
        delete={deleteAction}
        {...props.additionalActions}>
          <Form
            data={data}
            localize={localize}
            updateEntity={propName => updateEntity(propName, props)}
            delete={deleteAction}
            save={save}
            {...otherProps} />
      </DetailPage>
    )
  }

  const mapDispatchToProps = {
    get: actionCreators.get,
    update: actionCreators.update,
    save: actionCreators.save,
    delete: actionCreators.delete,
    ...actionCreators.additionalActions
  }

  return connect(
    (state) => ({ [metadata.page]: state[metadata.page] }),
    mapDispatchToProps)(localized(CommonDetailPage))
}

export {
  createDetailPage
}
